import { UnreadBadge } from 'src/components/unread-badge';
import { useChatsUnreadCount } from 'src/hooks/use-chats-unread-count';

export function ChatsNavBadge() {
  const totalUnread = useChatsUnreadCount();

  return <UnreadBadge count={totalUnread} />;
}
